import { PRODUCT_TYPE_NAMES } from 'bundles/browse-common/constants';
import {
  buildCertificatesUrlAbsolute,
  buildDegreeUrlAbsolute,
  buildMastertrackUrlAbsolute,
  buildS12nsUrlAbsolute,
} from 'bundles/common/utils/urlUtils';

export const buildProgramAbsoluteUrl = (slug: string, programType: string): string => {
  switch (programType) {
    case PRODUCT_TYPE_NAMES.DEGREE:
      return buildDegreeUrlAbsolute(slug);
    case PRODUCT_TYPE_NAMES.CERTIFICATE:
      return buildCertificatesUrlAbsolute(slug);
    case PRODUCT_TYPE_NAMES.SPECIALIZATION:
      return buildS12nsUrlAbsolute(slug);
    default:
      return buildMastertrackUrlAbsolute(slug);
  }
};
